import React from 'react'


import {
    ServiceContainer,
    ServicesTextWrapper,
    ServiceWrapper,
    ServiceRow,

    ServicesCard,
    ServicesH1,
    ServicesH2,
    ServicesIcon,
    ServicesP
} from './ServiceElements'


const ServiceSection = ({type,lightBg,id,imgStart,title1, title2, title3, title4,title5,title6,title7,title8, p1,p2,p3,p4,p5,p6,p7,p8, Icon1, Icon2,Icon3,Icon4,Icon5,Icon6,Icon7,Icon8}) => {
    return (
        <>
            <ServiceContainer id='services'>
                <ServicesTextWrapper>
                    <ServicesH1>Our Services</ServicesH1>
                </ServicesTextWrapper>
                <ServiceWrapper>
                    <ServiceRow>
                        <ServicesCard white={true}>
                                <ServicesIcon src={Icon1} />
                                <ServicesH2>{title1}</ServicesH2>
                                <ServicesP>{p1}</ServicesP>
                            </ServicesCard>
                        <ServicesCard white={true}>
                                <ServicesIcon src={Icon2} />
                                <ServicesH2>{title2}</ServicesH2>
                                <ServicesP>{p2}</ServicesP>
                            </ServicesCard>
                        <ServicesCard white={true}>
                                <ServicesIcon src={Icon3} />
                                <ServicesH2>{title3}</ServicesH2>
                                <ServicesP>{p3}</ServicesP>
                            </ServicesCard>
                      
                    </ServiceRow>
                    <ServiceRow>
                    <ServicesCard white={true}>
                                <ServicesIcon src={Icon4} />
                                <ServicesH2 small>{title4}</ServicesH2>
                                <ServicesP>{p4}</ServicesP>
                            </ServicesCard>
                        <ServicesCard white={true}>
                                <ServicesIcon src={Icon5} />
                                <ServicesH2>{title5}</ServicesH2>
                                <ServicesP>{p5}</ServicesP>
                            </ServicesCard>
                        <ServicesCard white={true}>
                                <ServicesIcon src={Icon7} />
                                <ServicesH2>{title7}</ServicesH2>
                                <ServicesP>{p7}</ServicesP>
                            </ServicesCard>
                    </ServiceRow>
                </ServiceWrapper>
            </ServiceContainer>
        </>
    )
}

export default ServiceSection
